import UnitDetails from './UnitDetails';

export default UnitDetails;
